<app-header></app-header>

<main class="tips-container">
  <section class="hero-section">
    <div class="hero-content">
      <h1 class="hero-title">
        Marketing Tips for
        <span class="gradient-text">Success</span>
      </h1>
      <p class="hero-subtitle">
        Boost your sales with these proven strategies for creating standout
        listings
      </p>
      <div class="hero-divider"></div>
    </div>
  </section>

  <section class="tips-section">
    <div class="tips-container-inner">
      <div class="tips-list">
        <div *ngFor="let tip of tips" class="tip-card">
          <button (click)="toggleExpand(tip.id)" class="tip-header">
            <div class="tip-header-content">
              <div class="tip-icon">
                {{ tip.icon }}
              </div>

              <h3 class="tip-title">
                {{ tip.title }}
              </h3>

              <div class="expand-icon" [class.expanded]="tip.expanded">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                  />
                </svg>
              </div>
            </div>
          </button>

          <div class="tip-content" [class.expanded]="tip.expanded">
            <div class="tip-content-inner">
              <p class="tip-description">
                {{ tip.description }}
              </p>

              <div class="pro-tips">
                <h4 class="pro-tips-title">
                  <span class="pro-tips-icon">💡</span>
                  Pro Tips:
                </h4>
                <ul class="pro-tips-list">
                  <li *ngFor="let example of tip.examples" class="pro-tip-item">
                    <span class="pro-tip-bullet"></span>
                    <span class="pro-tip-text">{{ example }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="stats-section">
    <div class="stats-container">
      <div class="stats-grid">
        <div class="stat-item">
          <div class="stat-value">68%</div>
          <p class="stat-label">Higher chance of selling with quality photos</p>
        </div>

        <div class="stat-item">
          <div class="stat-value">45%</div>
          <p class="stat-label">More views with optimized titles</p>
        </div>

        <div class="stat-item">
          <div class="stat-value">3x</div>
          <p class="stat-label">Faster sales with detailed descriptions</p>
        </div>
      </div>
    </div>
  </section>

  <section class="cta-section">
    <div class="cta-container">
      <div class="cta-card">
        <h2 class="cta-title">Ready to Create Your Listing?</h2>
        <p class="cta-description">
          Apply these tips and start showcasing your products today
        </p>
        <button class="cta-button" (click)="goToSell()">
          Start Selling Now
        </button>
      </div>
    </div>
  </section>
</main>

<app-footer></app-footer>
